import { render, staticRenderFns } from "./pass-list-item.vue?vue&type=template&id=2818e404&scoped=true"
import script from "./pass-list-item.vue?vue&type=script&lang=js"
export * from "./pass-list-item.vue?vue&type=script&lang=js"
import style0 from "./pass-list-item.vue?vue&type=style&index=0&id=2818e404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818e404",
  null
  
)

export default component.exports